import { BaseEntity } from './base-entity';
import { AssessmentStatus } from './assessment-status';
import { AssessmentComment } from './assessment-comment';
import { RiskFormula } from './risk-formula';
import { RiskBand } from './risk-band';
import { RiskFactor } from './risk-factor';

export class Assessment extends BaseEntity {
  parent: BaseEntity;
  status: AssessmentStatus;
  percentInt: number;
  riskFormula: RiskFormula;
  dueDate: Date;
  riskBands: Array<RiskBand>;
  factors: Array<RiskFactor>;
  comments: Array<AssessmentComment>;
  description: string;
  lastDistributionDate: Date;
}
